import { render } from "./Pill.vue?vue&type=template&id=4228f04a&scoped=true"
const script = {}

import "./Pill.vue?vue&type=style&index=0&id=4228f04a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4228f04a"]])

export default __exports__